import requests2 from "./requests2";
import qs from 'qs'
// import mockRequests from "./mockRequests";
//登录的接口:请求体携带参数 phone&&password
// export const reqUserLogin = (data)=>{
//     //requests({url:`api.php?op=vote_review&act=login`,method:'post',data});
//     console.log('login request');
//     return mockRequests({url:`/login`,method:'post',data});
// };

export const reqLearnList = (data, params)=>{
    return requests2({
        method: 'get',
        url: 'uploadfile/json/learn_'+params.learnid+'_'+params.page+'.json?'+Math.floor(Math.random() * 9999),
        data: qs.stringify(data),
        params: data 
    })
}

export const reqLession = (data, params)=>{
    console.log('data',data);
    return requests2({
        method: 'get',
        url: 'uploadfile/json/lession_'+data.lessionid+'.json?'+Math.floor(Math.random() * 9999),
        data: qs.stringify(data),
        params: data 
    })
}

export const reqArea = (data, params)=>{
    console.log('data',data);
    return requests2({
        method: 'get',
        url: 'uploadfile/json/linkage_'+data.linkageid+'.json?'+Math.floor(Math.random() * 9999),
        data: qs.stringify(data),
        params: data 
    })
}
